import * as Sentry from '@sentry/solid'

const automaticErrorIntegrations = new Set([
  'GlobalHandlers',
  'BrowserApiErrors',
])

Sentry.init({
  dsn: 'https://92f95b0e229c6fb2636b2e81c9206ea6@o4508877765869568.ingest.us.sentry.io/4511466468147200',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations(defaultIntegrations) {
    return defaultIntegrations.filter(
      (integration) => !automaticErrorIntegrations.has(integration.name),
    )
  },
})
